module.exports = __webpack_public_path__ + "static/media/mobile-sides.3a6b8340.png";